const FAQAPI = {
  general: [
    {
      id: 0,
      question: `How should I dress for my session?`,
      answer: `You can come in whatever you are comfortable with. During the massage you will be undressed to your comfort level(either naked or in underwear is typical). The areas I am not working on will be draped with a sheet and blanket.`,
    },
    {
      id: 1,
      question: `Do I need to eat/drink before my session?`,
      answer: `Coming into the massage feeling hydrated and consuming a light meal before will ensure you will be comfortable during the massage session.`,
    },
    {
      id: 2,
      question: `What if I don't want to talk during my session?`,
      answer: `his is very common and not a problem at all. I will check in about comfort and pressure throughout the session but can be silent otherwise. I always defer to what the client wants from the experience!`,
    },
  ],

  massage: [
    {
      id: 0,
      question: `What are the benefits of massage?`,
      answer: `There are many benefits of massage including relaxation, stress reduction, injury prevention, increased range of motion, improved sleep, decrease of pain amongst others.`,
    },
    {
      id: 1,
      question: `What ailments can your massage relieve?`,
      answer: `Massage can help with muscle stiffness or soreness, pain, headaches, injury healing, TMJD, plantar fasciitis, sciatica.`,
    },
    {
      id: 2,
      question: `How are you different from other massage therapists?`,
      answer: `I use a variety of techniques that I've studied blended into a session based on how the body is responding. I never charge an add on fee for different specialties. I am truly passionate about my work and feel it is my best compliment from my clients when they say they can feel how much I love what I do! I listen and adapt and use my gift of intuition and creativity in every single session.`,
    },
    {
      id: 3,
      question: `I am pregnant, can I still receive massage therapy?`,
      answer: `Yes! I am trained in prenatal massage and recommend starting in the second trimester by booking a 60 or 90 minute fully customized massage. `,
    },
    {
      id: 4,
      question: `Can I workout after a massage? `,
      answer: `Yes, but keep it something light if you do. To get the most benefit from your massage, it is best to work out before. Your muscles will l be warmed up for the massage. Working out immediately after could cause strain to your body. It is best to wait 12-24 hours before exercising to let your muscles recover. `,
    },
    {
      id: 5,
      question: `What is the best way to maintain the positive effects of the massage? `,
      answer: `Staying hydrated and allowing time for rest or light stretching. Epsom salt soaks are also a great way to help with recovery. Eating a nourishing and clean meal after can also help. Also pre booking your next massage to get yourself on a regular self care schedule is recommended. `,
    },
    {
      id: 6,
      question: `How do I know I need a massage?`,
      answer: `If you are feeling stressed out, overwhelmed, tight, sore or like you're not getting the most out of your workouts you may benefit from massage therapy.`,
    },

    {
      id: 7,
      question: `What type of clients do you typically see?`,
      answer: `I see a range of clients for regular “tune up” massages. Typically late 20s-60s who either work 
        Either at a desk or on their feet and stay active in their personal life.  My clients want to take care of their bodies and mind with regular massage. Clients come to me seeking preventative care to make sure they can live their best lives.`,
    },

    {
      id: 8,
      question: `How do you know what to work on during a massage?`,
      answer: `I send an intake form via email prior to the session which will give me a good idea of your concerns, contraindications and goals. Before every session there is always time to check in and discuss what the main goals are for that session. Based off of this info I tailor the massage.`,
    },

    {
      id: 9,
      question: `How often should I get a massage?`,
      answer: `It depends on your goals but typically a 4-6 period between massages is great for maintenance. If you are working on something specific every week for 5-6 weeks is helpful but would also recommend seeking other providers as well (ex: Physic Therapist, Chiropractic, acupuncturist, personal trainer)`,
    },

    {
      id: 10,
      question: `What if I don't feel uncomfortable undressing?`,
      answer: `We can work through the clothing using compression and stretching if you are uncomfortable undressing.`,
    },

    {
      id: 11,
      question: `What if there's too much or not enough pressure during the massage?`,
      answer: `I  will check in periodically but always encourage you to let me know at any point if you would prefer a different pressure.`,
    },
  ],

  reiki: [
    {
      id: 0,
      question: `What is reiki?`,
      answer: `Reiki is an ancient Japanese healing technique that I am formally trained in under a Reiki Master Teacher. The goal of reiki is to help bring calm, peace and balance to the bodies energetic system. This is done through a series of very gentle hand placement along the body from the crown of the head to the feet. 
      Translated Reiki means “Universal Energy” and as a practitioner I channel the universal energies through my palms into your body to promote healing. `,
    },

    {
      id: 1,
      question: `What are the benefits of reiki?`,
      answer: `Reiki can help support you while you're experiencing anxiety, fatigue, depression, grief, overwhelm or pain. Reiki can bring you the comfort, space and time to bring you back to yourself and let go of anything that is no longer serving you. `,
    },

    {
      id: 2,
      question: `What happens during a reiki session?`,
      answer: `During a reiki session you can either remain in your clothing or undress and get under the sheet and blanket based on your preference. I will use gentle hand movement from head to toe while you lay down listening to calming music  there is no oil or cream involved but we can add some aromatherapy if that helps you feel more relaxed. `,
    },

    {
      id: 3,
      question: `How do I know it's working?`,
      answer: `Everyone experiences reiki in different ways depending on what areas of the energetic body are coming into balance. Typically slower breathing, a more calm mind and feeling warmth or a buzzing/light tingle are signs that the reiki is flowing though your body. `,
    },

    {
      id: 4,
      question: `How do I know when I need reiki?`,
      answer: `You can benefit from reiki any time ( I practice self reiki daily) so it is always a good time to book! `,
    },

    {
      id: 5,
      question: `What type of clients do you typically see?`,
      answer: `my reiki clients typically are in their 20s-60s and are seeking relief from their daily stresses, grief, sadness, depression, anxiety or are looking to build a deeper relationship with their energetic bodies. `,
    },

    {
      id: 6,
      question: `Why should someone see you for reiki?`,
      answer: `I practice reiki daily on myself and discovered reiki at a time of great sadness in my life. Regular reiki sessions helped me work though a lot of things that were blocking me from my goals. I have a passion to share what helped me so much with others. `,
    },
  ],
  yoga: [
    {
      id: 1,
      question: `What if I am not flexible?`,
      answer: `My yoga classes are for all abilities. Everyone is welcome. `,
    },
    {
      id: 2,
      question: `What if I have injuries?`,
      answer: `You can let me know before class of any injuries or concerns so we can modify. The class is very gentle and slow paced. `,
    },
    {
      id: 3,
      question: `Do you offer group classes?`,
      answer: `Weekly small group yoga classes are available`,
    },
    {
      id: 4,
      question: `Do you offer 1:1 sessions?`,
      answer: `I offer foundation/beginner yoga sessions for 1:1.`,
    },
    {
      id: 5,
      question: `Are your yoga sessions tailored to individual client needs?`,
      answer: `The one on one yoga option is a foundational/beginners focused offering. The sessions will be tailored to your goals and what is comfortable for you. `,
    },
    {
      id: 6,
      question: `What do group classes look like?`,
      answer: `The yoga class is a small group (6 students max) and it is a slow flow of yoga and a series of restorative yoga posters with reiki and gentle craniosacral infused in by me. `,
    },
    {
      id: 7,
      question: `How often should I do yoga?`,
      answer: `I encourage and empower everyone to take their yoga practice and make it fit their lifestyle. `,
    },
    {
      id: 8,
      question: `How is your yoga different than other yoga teachers?`,
      answer: `I bring in a strong knowledge of human anatomy with my massage therapist training.  I also have it in my scope to assist with hands on adjustments and light massage during the longer held restorative postures. I also keep my classes small so I can be aware of all students. `,
    },
    {
      id: 9,
      question: `What kind of yoga do you teach?`,
      answer: `Slow flow and restorative yoga.`,
    },
    {
      id: 10,
      question: `Who should see you for yoga sessions?`,
      answer: `Anyone who is looking to escape the hustle and bustle and tap into a quiet space inside of themselves.  `,
    },
    {
      id: 11,
      question: `What certifications do you have?`,
      answer: `I am 200 hour certified yoga instructor via Health Yoga Life in Boston where I Studied in January 2020. `,
    },
    {
      id: 12,
      question: `How do you plan your yoga classes?`,
      answer: `I plan my yoga classes to be a class I would love to take. A class that warms up the entire body and allows the mind to rest and relax for the 75 minutes we are together. All the little details come together to make the experience magic. `,
    },
  ],
  cupping: [
    {
      id: 0,
      question: `What is cupping?`,
      answer: `“Cupping therapy can be used to move stagnation, relieve inflammation, and drain/move fluids. The mechanism is to draw blood from the arteries to the capillaries. The blood then returns via the veins to be cleansed or disposed of. Cupping is not an irritant to the skin or body. It draws the inflammation out but does not add to it. ACE Massage Cupping & MediCupping is also used to lift and stretch soft tissue (muscle, fascia/connective, attachments), separate fused tissue layers (i.e. ITB and TFL), release and soften scar tissue, open body drainage systems to aid in decongesting “solid bloat” and increase hydration of tissues. Bones also respond well to treatment.” ACE CUPPING `,
    },

    {
      id: 1,
      question: `What is recommended after care for cupping? `,
      answer: ` Staying hydrated helps flush your lymphatic system of the cellular waste that cupping helps release from your tissues.  Try to cover the marks from direct sun & allow time for your body to rest and integrate the change that occurred during the treatment. `,
    },
  ],
};

export default FAQAPI;
